<div class="sp-page">

  <!-- ── Sidebar ──────────────────────────────────────────────────── -->
  <aside class="sp-sidebar">

    <!-- Avatar + nombre -->
    <div class="sp-profile-card">
      <div class="sp-avatar-wrap">
        <img [src]="datosUsuario.profileFileUrl || 'assets/images/user.png'"
             alt="Foto de perfil"
             class="sp-avatar">
        <button class="sp-avatar-edit" (click)="triggerFileInput()" matTooltip="Cambiar foto">
          <mat-icon>camera_alt</mat-icon>
        </button>
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" hidden>
      </div>
      <p class="sp-profile-name">{{ datosUsuario.firstName }} {{ datosUsuario.lastName }}</p>
      <p class="sp-profile-email">{{ datosUsuario.email }}</p>
    </div>

    <!-- Menú de navegación -->
    <nav class="sp-nav">
      <button class="sp-nav-btn" [class.sp-nav-btn--active]="selectedTab === 0" (click)="selectTab(0)">
        <mat-icon class="sp-nav-icon">person_outline</mat-icon>
        <span>Editar perfil</span>
      </button>
      <button class="sp-nav-btn" [class.sp-nav-btn--active]="selectedTab === 1" (click)="selectTab(1)">
        <mat-icon class="sp-nav-icon">lock_outline</mat-icon>
        <span>Actualizar contraseña</span>
      </button>
      <button class="sp-nav-btn" [class.sp-nav-btn--active]="selectedTab === 2" (click)="selectTab(2)">
        <mat-icon class="sp-nav-icon">credit_card</mat-icon>
        <span>Mi suscripción</span>
      </button>
      <button class="sp-nav-btn" [class.sp-nav-btn--active]="selectedTab === 3" (click)="selectTab(3)">
        <mat-icon class="sp-nav-icon">receipt_long</mat-icon>
        <span>Historial de pagos</span>
      </button>
    </nav>

  </aside>

  <!-- ── Contenido principal ──────────────────────────────────────── -->
  <main class="sp-main">

    <!-- ════ EDITAR PERFIL ════ -->
    <div *ngIf="selectedTab === 0" class="sp-section">

      <!-- Sub-tabs de perfil -->
      <nav class="sp-subtab-bar">
        <button class="sp-subtab" [class.sp-subtab--active]="profileSubTab === 0" (click)="profileSubTab = 0">
          <mat-icon>manage_accounts</mat-icon> Mi cuenta
        </button>
        <button class="sp-subtab" [class.sp-subtab--active]="profileSubTab === 1" (click)="profileSubTab = 1">
          <mat-icon>badge</mat-icon> Perfil profesional
        </button>
        <button class="sp-subtab" [class.sp-subtab--active]="profileSubTab === 2" (click)="profileSubTab = 2">
          <mat-icon>school</mat-icon> Educación
        </button>
        <button class="sp-subtab" [class.sp-subtab--active]="profileSubTab === 3" (click)="profileSubTab = 3">
          <mat-icon>work_outline</mat-icon> Experiencia
        </button>
        <button class="sp-subtab" [class.sp-subtab--active]="profileSubTab === 4" (click)="profileSubTab = 4">
          <mat-icon>emoji_events</mat-icon> Proyectos
        </button>
      </nav>

      <!-- ── 0: Mi cuenta ─────────────────────────────────────────── -->
      <div *ngIf="profileSubTab === 0" class="sp-card">
        <div class="sp-card-head">
          <span class="sp-card-title">Información de cuenta</span>
          <button class="l-btn l-btn--outline l-btn--sm" (click)="toggleEditMode()">
            <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
            {{ editMode ? 'Guardar' : 'Editar' }}
          </button>
        </div>
        <div class="sp-card-body">
          <form (ngSubmit)="onSubmit()" novalidate>
            <div class="sp-form-grid">
              <mat-form-field appearance="outline" class="sp-field">
                <mat-label>Nombre(s)</mat-label>
                <input matInput [(ngModel)]="datosUsuario.firstName" name="firstName"
                       [readonly]="!editMode" required>
                <mat-icon matSuffix>person</mat-icon>
              </mat-form-field>
              <mat-form-field appearance="outline" class="sp-field">
                <mat-label>Apellido(s)</mat-label>
                <input matInput [(ngModel)]="datosUsuario.lastName" name="lastName"
                       [readonly]="!editMode" required>
                <mat-icon matSuffix>person</mat-icon>
              </mat-form-field>
              <mat-form-field appearance="outline" class="sp-field">
                <mat-label>Correo electrónico</mat-label>
                <input matInput [(ngModel)]="datosUsuario.email" name="email" type="email" readonly>
                <mat-icon matSuffix>email</mat-icon>
              </mat-form-field>
              <mat-form-field appearance="outline" class="sp-field">
                <mat-label>Teléfono</mat-label>
                <input matInput [(ngModel)]="datosUsuario.phoneNumber" name="phoneNumber"
                       [readonly]="!editMode">
                <mat-icon matSuffix>phone</mat-icon>
              </mat-form-field>
            </div>
            <div *ngIf="editMode" class="sp-form-actions">
              <button type="submit" class="l-btn l-btn--primary">
                <mat-icon>save</mat-icon> Guardar cambios
              </button>
              <button type="button" class="l-btn l-btn--ghost" (click)="editMode = false">Cancelar</button>
            </div>
          </form>
        </div>
      </div>

      <!-- ── 1: Perfil profesional ─────────────────────────────────── -->
      <div *ngIf="profileSubTab === 1" class="sp-section-inner">

        <!-- Banner de perfil -->
        <div class="sp-card sp-banner-card">
          <div class="sp-banner-preview"
               [style.backgroundImage]="bannerUrl ? 'url(' + bannerUrl + ')' : 'none'">
            <div class="sp-banner-overlay" *ngIf="!bannerUrl">
              <mat-icon>image</mat-icon>
              <span>Banner de perfil público</span>
            </div>
          </div>
          <div class="sp-banner-actions">
            <div class="sp-field-block">
              <label class="sp-label-sm">URL del banner</label>
              <input class="sp-input" [(ngModel)]="bannerUrl" placeholder="https://..." type="url">
            </div>
          </div>
        </div>

        <!-- Foto + datos básicos -->
        <div class="sp-card">
          <div class="sp-card-body">
            <div class="sp-prof-grid">

              <!-- Foto de perfil -->
              <div class="sp-prof-photo">
                <div class="sp-avatar-wrap">
                  <img [src]="datosUsuario.profileFileUrl || 'assets/images/user.png'"
                       alt="Foto de perfil" class="sp-avatar sp-avatar--lg">
                  <button class="sp-avatar-edit" (click)="triggerFileInput()" matTooltip="Cambiar foto">
                    <mat-icon>camera_alt</mat-icon>
                  </button>
                </div>
                <p class="sp-hint">Foto de perfil público<br><span>Recomendado: 400 × 400 px</span></p>
              </div>

              <!-- Categoría + Bio -->
              <div class="sp-prof-data">
                <div class="sp-field-block">
                  <label class="sp-label-sm">Categoría profesional</label>
                  <select class="sp-select" [(ngModel)]="profileCategory">
                    <option value="">— Selecciona una categoría —</option>
                    <option *ngFor="let cat of CATEGORIES" [value]="cat">{{ cat }}</option>
                  </select>
                </div>
                <div class="sp-field-block">
                  <label class="sp-label-sm">Bio / Acerca de</label>
                  <textarea class="sp-textarea" [(ngModel)]="datosUsuario.biography"
                            rows="5" placeholder="Describe tu perfil profesional, especialidades y propuesta de valor…"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sp-form-actions">
          <button class="l-btn l-btn--primary" (click)="saveProfessionalProfile()">
            <mat-icon>save</mat-icon> Guardar perfil profesional
          </button>
        </div>
      </div>

      <!-- ── 2: Educación ──────────────────────────────────────────── -->
      <div *ngIf="profileSubTab === 2" class="sp-section-inner">
        <div class="sp-list-header">
          <div>
            <p class="sp-list-title">Educación</p>
            <p class="sp-list-desc">Agrega tu formación académica y certificaciones</p>
          </div>
          <button class="l-btn l-btn--primary l-btn--sm" (click)="openAddEducation()">
            <mat-icon>add</mat-icon> Agregar
          </button>
        </div>

        <!-- Formulario de educación -->
        <div *ngIf="showEducationForm" class="sp-card sp-form-card">
          <div class="sp-card-head">
            <span class="sp-card-title">{{ editingEducationIdx >= 0 ? 'Editar educación' : 'Nueva educación' }}</span>
            <button class="l-btn l-btn--ghost l-btn--sm" (click)="showEducationForm = false">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="sp-card-body">
            <div class="sp-form-grid">
              <div class="sp-field-block">
                <label class="sp-label-sm">Institución *</label>
                <input class="sp-input" [(ngModel)]="educationForm.institution" placeholder="Ej: UNAM, MIT, Coursera">
              </div>
              <div class="sp-field-block">
                <label class="sp-label-sm">Título / Grado *</label>
                <input class="sp-input" [(ngModel)]="educationForm.degree" placeholder="Ej: Licenciatura, Maestría, Certificado">
              </div>
              <div class="sp-field-block">
                <label class="sp-label-sm">Área de estudio</label>
                <input class="sp-input" [(ngModel)]="educationForm.field" placeholder="Ej: Ingeniería en Sistemas">
              </div>
              <div class="sp-field-block sp-field--row">
                <div class="sp-field-block">
                  <label class="sp-label-sm">Año de inicio</label>
                  <input class="sp-input" [(ngModel)]="educationForm.startYear" placeholder="2018" type="number" min="1950" max="2099">
                </div>
                <div class="sp-field-block" *ngIf="!educationForm.current">
                  <label class="sp-label-sm">Año de fin</label>
                  <input class="sp-input" [(ngModel)]="educationForm.endYear" placeholder="2022" type="number" min="1950" max="2099">
                </div>
                <label class="sp-check-row">
                  <input type="checkbox" [(ngModel)]="educationForm.current">
                  <span>En curso</span>
                </label>
              </div>
              <div class="sp-field-block sp-field--full">
                <label class="sp-label-sm">Descripción (opcional)</label>
                <textarea class="sp-textarea" [(ngModel)]="educationForm.description" rows="3"
                          placeholder="Logros, actividades relevantes…"></textarea>
              </div>
            </div>
            <div class="sp-form-actions">
              <button class="l-btn l-btn--primary" (click)="saveEducation()">
                <mat-icon>save</mat-icon> Guardar
              </button>
              <button class="l-btn l-btn--ghost" (click)="showEducationForm = false">Cancelar</button>
            </div>
          </div>
        </div>

        <!-- Lista de educación -->
        <div *ngIf="educationItems.length === 0 && !showEducationForm" class="sp-empty sp-card">
          <mat-icon class="sp-empty-icon">school</mat-icon>
          <p class="sp-empty-desc">Aún no has agregado formación académica</p>
          <button class="l-btn l-btn--outline" (click)="openAddEducation()">
            <mat-icon>add</mat-icon> Agregar educación
          </button>
        </div>

        <div class="sp-timeline" *ngIf="educationItems.length > 0">
          <div *ngFor="let item of educationItems; let i = index" class="sp-timeline-item">
            <div class="sp-timeline-dot">
              <mat-icon>school</mat-icon>
            </div>
            <div class="sp-timeline-body">
              <div class="sp-timeline-head">
                <div>
                  <p class="sp-timeline-title">{{ item.degree }}</p>
                  <p class="sp-timeline-sub">{{ item.institution }}<span *ngIf="item.field"> · {{ item.field }}</span></p>
                  <p class="sp-timeline-period">
                    {{ item.startYear }}<span *ngIf="!item.current && item.endYear"> – {{ item.endYear }}</span>
                    <span *ngIf="item.current" class="sp-badge sp-badge--accent ml-2">En curso</span>
                  </p>
                </div>
                <div class="sp-timeline-actions">
                  <button class="l-btn l-btn--ghost l-btn--sm" (click)="openEditEducation(i)" matTooltip="Editar">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button class="l-btn l-btn--ghost l-btn--sm sp-danger-btn" (click)="removeEducation(i)" matTooltip="Eliminar">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
              <p *ngIf="item.description" class="sp-timeline-desc">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ── 3: Experiencia ────────────────────────────────────────── -->
      <div *ngIf="profileSubTab === 3" class="sp-section-inner">
        <div class="sp-list-header">
          <div>
            <p class="sp-list-title">Experiencia profesional</p>
            <p class="sp-list-desc">Agrega tus empleos, freelance y consultorías</p>
          </div>
          <button class="l-btn l-btn--primary l-btn--sm" (click)="openAddExperience()">
            <mat-icon>add</mat-icon> Agregar
          </button>
        </div>

        <!-- Formulario de experiencia -->
        <div *ngIf="showExperienceForm" class="sp-card sp-form-card">
          <div class="sp-card-head">
            <span class="sp-card-title">{{ editingExperienceIdx >= 0 ? 'Editar experiencia' : 'Nueva experiencia' }}</span>
            <button class="l-btn l-btn--ghost l-btn--sm" (click)="showExperienceForm = false">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="sp-card-body">
            <div class="sp-form-grid">
              <div class="sp-field-block">
                <label class="sp-label-sm">Empresa / Cliente *</label>
                <input class="sp-input" [(ngModel)]="experienceForm.company" placeholder="Ej: Google, Freelance">
              </div>
              <div class="sp-field-block">
                <label class="sp-label-sm">Cargo / Rol *</label>
                <input class="sp-input" [(ngModel)]="experienceForm.role" placeholder="Ej: Product Manager">
              </div>
              <div class="sp-field-block">
                <label class="sp-label-sm">Área</label>
                <input class="sp-input" [(ngModel)]="experienceForm.area" placeholder="Ej: Desarrollo de producto">
              </div>
              <div class="sp-field-block sp-field--row">
                <div class="sp-field-block">
                  <label class="sp-label-sm">Fecha de inicio</label>
                  <input class="sp-input" [(ngModel)]="experienceForm.startDate" type="month">
                </div>
                <div class="sp-field-block" *ngIf="!experienceForm.current">
                  <label class="sp-label-sm">Fecha de fin</label>
                  <input class="sp-input" [(ngModel)]="experienceForm.endDate" type="month">
                </div>
                <label class="sp-check-row">
                  <input type="checkbox" [(ngModel)]="experienceForm.current">
                  <span>Trabajo actual</span>
                </label>
              </div>
              <div class="sp-field-block sp-field--full">
                <label class="sp-label-sm">Descripción</label>
                <textarea class="sp-textarea" [(ngModel)]="experienceForm.description" rows="3"
                          placeholder="Logros, responsabilidades, impacto…"></textarea>
              </div>
            </div>
            <div class="sp-form-actions">
              <button class="l-btn l-btn--primary" (click)="saveExperience()">
                <mat-icon>save</mat-icon> Guardar
              </button>
              <button class="l-btn l-btn--ghost" (click)="showExperienceForm = false">Cancelar</button>
            </div>
          </div>
        </div>

        <!-- Lista de experiencia -->
        <div *ngIf="experienceItems.length === 0 && !showExperienceForm" class="sp-empty sp-card">
          <mat-icon class="sp-empty-icon">work_outline</mat-icon>
          <p class="sp-empty-desc">Aún no has agregado experiencia profesional</p>
          <button class="l-btn l-btn--outline" (click)="openAddExperience()">
            <mat-icon>add</mat-icon> Agregar experiencia
          </button>
        </div>

        <div class="sp-timeline" *ngIf="experienceItems.length > 0">
          <div *ngFor="let item of experienceItems; let i = index" class="sp-timeline-item">
            <div class="sp-timeline-dot">
              <mat-icon>work_outline</mat-icon>
            </div>
            <div class="sp-timeline-body">
              <div class="sp-timeline-head">
                <div>
                  <p class="sp-timeline-title">{{ item.role }}</p>
                  <p class="sp-timeline-sub">{{ item.company }}<span *ngIf="item.area"> · {{ item.area }}</span></p>
                  <p class="sp-timeline-period">
                    {{ item.startDate | date:'MM/yyyy' }}
                    <span *ngIf="!item.current && item.endDate"> – {{ item.endDate | date:'MM/yyyy' }}</span>
                    <span *ngIf="item.current" class="sp-badge sp-badge--accent ml-2">Actual</span>
                  </p>
                </div>
                <div class="sp-timeline-actions">
                  <button class="l-btn l-btn--ghost l-btn--sm" (click)="openEditExperience(i)" matTooltip="Editar">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button class="l-btn l-btn--ghost l-btn--sm sp-danger-btn" (click)="removeExperience(i)" matTooltip="Eliminar">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
              <p *ngIf="item.description" class="sp-timeline-desc">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ── 4: Proyectos / Casos de éxito ─────────────────────────── -->
      <div *ngIf="profileSubTab === 4" class="sp-section-inner">
        <div class="sp-list-header">
          <div>
            <p class="sp-list-title">Proyectos y casos de éxito</p>
            <p class="sp-list-desc">Muestra tu portafolio y resultados destacados</p>
          </div>
          <button class="l-btn l-btn--primary l-btn--sm" (click)="openAddProject()">
            <mat-icon>add</mat-icon> Agregar
          </button>
        </div>

        <!-- Formulario de proyecto -->
        <div *ngIf="showProjectForm" class="sp-card sp-form-card">
          <div class="sp-card-head">
            <span class="sp-card-title">{{ editingProjectIdx >= 0 ? 'Editar proyecto' : 'Nuevo proyecto' }}</span>
            <button class="l-btn l-btn--ghost l-btn--sm" (click)="showProjectForm = false">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="sp-card-body">
            <div class="sp-form-grid">
              <div class="sp-field-block sp-field--full">
                <label class="sp-label-sm">Título del proyecto *</label>
                <input class="sp-input" [(ngModel)]="projectForm.title" placeholder="Ej: Rediseño de e-commerce para Marca X">
              </div>
              <div class="sp-field-block sp-field--full">
                <label class="sp-label-sm">Descripción / Resultados</label>
                <textarea class="sp-textarea" [(ngModel)]="projectForm.description" rows="4"
                          placeholder="Describe el reto, tu rol, las acciones y los resultados obtenidos…"></textarea>
              </div>
              <div class="sp-field-block">
                <label class="sp-label-sm">URL del proyecto</label>
                <input class="sp-input" [(ngModel)]="projectForm.url" placeholder="https://..." type="url">
              </div>
              <div class="sp-field-block">
                <label class="sp-label-sm">URL de imagen de portada</label>
                <input class="sp-input" [(ngModel)]="projectForm.imageUrl" placeholder="https://..." type="url">
              </div>
              <div class="sp-field-block sp-field--full">
                <label class="sp-label-sm">Tecnologías / Habilidades (separadas por coma)</label>
                <input class="sp-input" [(ngModel)]="projectForm.tags" placeholder="Ej: Angular, UX, SEO, Copywriting">
              </div>
            </div>
            <div class="sp-form-actions">
              <button class="l-btn l-btn--primary" (click)="saveProject()">
                <mat-icon>save</mat-icon> Guardar
              </button>
              <button class="l-btn l-btn--ghost" (click)="showProjectForm = false">Cancelar</button>
            </div>
          </div>
        </div>

        <!-- Lista de proyectos -->
        <div *ngIf="projectItems.length === 0 && !showProjectForm" class="sp-empty sp-card">
          <mat-icon class="sp-empty-icon">emoji_events</mat-icon>
          <p class="sp-empty-desc">Aún no has agregado proyectos o casos de éxito</p>
          <button class="l-btn l-btn--outline" (click)="openAddProject()">
            <mat-icon>add</mat-icon> Agregar proyecto
          </button>
        </div>

        <div class="sp-project-grid" *ngIf="projectItems.length > 0">
          <div *ngFor="let item of projectItems; let i = index" class="sp-project-card">
            <div class="sp-project-cover"
                 [style.backgroundImage]="item.imageUrl ? 'url(' + item.imageUrl + ')' : 'none'">
              <div *ngIf="!item.imageUrl" class="sp-project-cover-empty">
                <mat-icon>image_not_supported</mat-icon>
              </div>
            </div>
            <div class="sp-project-body">
              <p class="sp-project-title">{{ item.title }}</p>
              <p class="sp-project-desc" *ngIf="item.description">{{ item.description }}</p>
              <div class="sp-project-tags" *ngIf="item.tags">
                <span *ngFor="let tag of item.tags.split(',')" class="sp-tag">{{ tag.trim() }}</span>
              </div>
              <div class="sp-project-footer">
                <a *ngIf="item.url" [href]="item.url" target="_blank" class="l-btn l-btn--ghost l-btn--sm">
                  <mat-icon>open_in_new</mat-icon> Ver proyecto
                </a>
                <div class="sp-project-actions">
                  <button class="l-btn l-btn--ghost l-btn--sm" (click)="openEditProject(i)" matTooltip="Editar">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button class="l-btn l-btn--ghost l-btn--sm sp-danger-btn" (click)="removeProject(i)" matTooltip="Eliminar">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- ════ ACTUALIZAR CONTRASEÑA ════ -->
    <div *ngIf="selectedTab === 1" class="sp-section">
      <header class="sp-section-header">
        <h2 class="sp-section-title">Actualizar contraseña</h2>
        <p class="sp-section-desc">Define una nueva contraseña para tu cuenta</p>
      </header>

      <div class="sp-card sp-card--narrow">
        <div class="sp-card-body">
          <form [formGroup]="passwordForm" (ngSubmit)="updatePassword()">
            <mat-form-field appearance="outline" class="sp-field w-100 mb-3">
              <mat-label>Correo electrónico</mat-label>
              <input matInput formControlName="email" type="email" readonly>
              <mat-icon matSuffix>email</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline" class="sp-field w-100 mb-3">
              <mat-label>Nueva contraseña</mat-label>
              <input matInput formControlName="password" type="password" autocomplete="new-password">
              <mat-icon matSuffix>lock</mat-icon>
              <mat-error *ngIf="passwordForm.get('password')?.hasError('required')">La contraseña es requerida</mat-error>
              <mat-error *ngIf="passwordForm.get('password')?.hasError('minlength')">Mínimo 8 caracteres</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="sp-field w-100 mb-4">
              <mat-label>Confirmar contraseña</mat-label>
              <input matInput formControlName="confirmPassword" type="password" autocomplete="new-password">
              <mat-icon matSuffix>lock_outline</mat-icon>
              <mat-error *ngIf="passwordForm.hasError('mismatch')">Las contraseñas no coinciden</mat-error>
            </mat-form-field>
            <button type="submit" class="l-btn l-btn--primary w-100"
                    [disabled]="passwordForm.invalid || changingPassword"
                    [class.l-btn--loading]="changingPassword">
              <mat-icon *ngIf="!changingPassword">save</mat-icon>
              {{ changingPassword ? 'Guardando…' : 'Actualizar contraseña' }}
            </button>
          </form>
        </div>
      </div>
    </div>

    <!-- ════ MI SUSCRIPCIÓN ════ -->
    <div *ngIf="selectedTab === 2" class="sp-section">
      <header class="sp-section-header">
        <h2 class="sp-section-title">Mi suscripción</h2>
        <p class="sp-section-desc">Consulta tu plan contratado y actualízalo cuando lo necesites</p>
      </header>

      <!-- Cargando suscripción -->
      <div *ngIf="loadingSubscription" class="sp-loading">
        <div class="sp-spinner"></div>
      </div>

      <!-- Sin suscripción -->
      <div *ngIf="!loadingSubscription && !subscription" class="sp-card sp-empty">
        <mat-icon class="sp-empty-icon">credit_card_off</mat-icon>
        <p class="sp-empty-title">Sin suscripción activa</p>
        <p class="sp-empty-desc">Contrata un plan para acceder a todos los módulos.</p>
        <button class="l-btn l-btn--primary" (click)="goToPlans()">Ver planes disponibles</button>
      </div>

      <!-- Con suscripción -->
      <ng-container *ngIf="!loadingSubscription && subscription">

        <!-- Banner del plan -->
        <div class="sp-plan-banner">
          <div class="sp-plan-banner__top">
            <div>
              <span class="sp-plan-banner__label">Plan activo</span>
              <h3 class="sp-plan-banner__name">{{ subscription.Plan?.name || 'Plan' }}</h3>
            </div>
            <span class="sp-badge" [ngClass]="subscriptionStatusClass(subscription.status)">
              {{ subscriptionStatusLabel(subscription.status) }}
            </span>
          </div>
          <p class="sp-plan-banner__price">
            ${{ subscription.Plan?.amount | number:'1.2-2' }}
            {{ subscription.Plan?.currency || 'MXN' }}
            <span class="sp-plan-banner__cycle">/ {{ repeatUnitLabel(subscription.Plan?.repeat_unit) }}</span>
          </p>
          <p class="sp-plan-banner__desc">{{ subscription.Plan?.description || 'Sin descripción del plan.' }}</p>
          <p class="sp-plan-banner__next">
            Próximo pago: <strong>{{ nextPaymentLabel() }}</strong>
          </p>
        </div>

        <!-- Cambiar plan -->
        <button type="button" class="l-btn l-btn--outline w-100 mb-3" (click)="togglePlanPicker()">
          <mat-icon>sync_alt</mat-icon>
          {{ showPlanPicker ? 'Ocultar planes' : 'Actualizar plan' }}
        </button>

        <div *ngIf="showPlanPicker && availablePlans.length" class="sp-card mb-4">
          <div class="sp-card-body">
            <p class="sp-label mb-3">Selecciona un plan</p>
            <div class="sp-plan-grid">
              <div *ngFor="let plan of availablePlans"
                   class="sp-plan-option"
                   [class.sp-plan-option--current]="plan.id === subscription.plan_id">
                <p class="sp-plan-option__name">{{ plan.name }}</p>
                <p class="sp-plan-option__price">${{ plan.amount | number:'1.2-2' }} / {{ repeatUnitLabel(plan.repeat_unit) }}</p>
                <p class="sp-plan-option__desc">{{ plan.description || '—' }}</p>
                <span *ngIf="plan.id === subscription.plan_id" class="sp-badge sp-badge--accent">Plan actual</span>
                <button *ngIf="plan.id !== subscription.plan_id"
                        class="l-btn l-btn--outline l-btn--sm mt-2"
                        (click)="upgradePlan(plan.id)">Elegir este plan</button>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Configurar mis herramientas (integrado aquí) ── -->
        <div class="sp-tools-section">
          <div class="sp-tools-header">
            <div>
              <p class="sp-tools-title">Mis herramientas</p>
              <p class="sp-tools-desc">Elige las herramientas activas incluidas en tu plan</p>
            </div>
            <button class="l-btn l-btn--outline l-btn--sm" (click)="toggleToolsPanel()">
              <mat-icon>{{ showToolsPanel ? 'expand_less' : 'settings' }}</mat-icon>
              {{ showToolsPanel ? 'Cerrar' : 'Configurar mis herramientas' }}
            </button>
          </div>

          <div *ngIf="showToolsPanel" class="sp-tools-panel">

            <!-- Cargando herramientas -->
            <div *ngIf="toolsLoading" class="sp-loading py-4">
              <div class="sp-spinner"></div>
            </div>

            <ng-container *ngIf="!toolsLoading && toolsData">

              <!-- Resumen del plan -->
              <div class="sp-tools-summary">
                <div class="sp-tools-stat">
                  <span class="sp-tools-stat__label">Plan</span>
                  <strong class="sp-tools-stat__val">{{ toolsData.planName || 'Gratuita' }}</strong>
                </div>
                <div class="sp-tools-stat">
                  <span class="sp-tools-stat__label">Herramientas activas</span>
                  <strong class="sp-tools-stat__val">{{ toolsActiveCount }} / {{ toolsMaxModules }}</strong>
                </div>
                <div class="sp-tools-stat">
                  <span class="sp-tools-stat__label">Disponibles</span>
                  <strong class="sp-tools-stat__val">{{ toolsRemaining }}</strong>
                </div>
                <span *ngIf="!toolsData.userConfigured" class="sp-badge sp-badge--neutral">
                  Selección sugerida automáticamente
                </span>
              </div>

              <!-- Tarjetas de herramientas -->
              <div class="sp-tool-grid">
                <div *ngFor="let tool of toolsData.tools"
                     class="sp-tool-card"
                     [class.sp-tool-card--on]="isToolSelected(tool)"
                     [class.sp-tool-card--disabled]="!tool.inPool">
                  <div class="sp-tool-card__head">
                    <label class="sp-tool-check">
                      <input type="checkbox"
                             [checked]="isToolSelected(tool)"
                             [disabled]="isToolDisabled(tool)"
                             (change)="toggleTool(tool, $any($event.target).checked)">
                      <span class="sp-tool-check__box"></span>
                    </label>
                    <span class="sp-tool-card__name">{{ tool.title }}</span>
                  </div>
                  <ul class="sp-tool-card__children" *ngIf="tool.children.length">
                    <li *ngFor="let child of tool.children">{{ child.title }}</li>
                  </ul>
                  <span *ngIf="!tool.inPool" class="sp-badge sp-badge--neutral mt-2">No incluida en tu plan</span>
                </div>
              </div>

              <!-- Guardar -->
              <div class="sp-tools-footer">
                <button class="l-btn l-btn--primary" (click)="saveMyTools()" [disabled]="toolsSaving"
                        [class.l-btn--loading]="toolsSaving">
                  <mat-icon *ngIf="!toolsSaving">save</mat-icon>
                  {{ toolsSaving ? 'Guardando…' : 'Guardar herramientas' }}
                </button>
              </div>

            </ng-container>
          </div>
        </div>

      </ng-container>
    </div>

    <!-- ════ HISTORIAL DE PAGOS ════ -->
    <div *ngIf="selectedTab === 3" class="sp-section">
      <header class="sp-section-header">
        <h2 class="sp-section-title">Historial de pagos</h2>
        <p class="sp-section-desc">Registro de cobros de tu suscripción recurrente</p>
      </header>

      <div *ngIf="paymentsLoading" class="sp-loading">
        <div class="sp-spinner"></div>
      </div>

      <div *ngIf="!paymentsLoading && payments.length === 0" class="sp-card sp-empty">
        <mat-icon class="sp-empty-icon">receipt_long</mat-icon>
        <p class="sp-empty-desc">No hay cobros registrados todavía.</p>
      </div>

      <div *ngIf="!paymentsLoading && payments.length > 0" class="sp-card">
        <div class="sp-table-wrap">
          <table class="sp-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Período</th>
                <th>Monto</th>
                <th>Estado</th>
                <th class="text-center">Intento</th>
                <th class="text-center">Comprobante</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of payments">
                <td>{{ (p.paid_at || p.created_at) | date:'dd/MM/yyyy' }}</td>
                <td>
                  <span *ngIf="p.period_start && p.period_end">
                    {{ p.period_start | date:'dd/MM' }} – {{ p.period_end | date:'dd/MM/yyyy' }}
                  </span>
                  <span *ngIf="!p.period_start" class="sp-muted">—</span>
                </td>
                <td><strong>${{ p.amount | number:'1.2-2' }}</strong> {{ p.currency }}</td>
                <td>
                  <span class="sp-badge" [ngClass]="paymentStatusClass(p.status)">
                    {{ paymentStatusLabel(p.status) }}
                  </span>
                </td>
                <td class="text-center">{{ p.attempt_number }}</td>
                <td class="text-center">
                  <button *ngIf="p.cfdi_url" class="l-btn l-btn--ghost l-btn--sm" (click)="downloadReceipt(p)">
                    <mat-icon>download</mat-icon>
                  </button>
                  <span *ngIf="!p.cfdi_url" class="sp-muted">—</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="sp-table-footer">
          <span class="sp-muted">{{ payments.length }} de {{ paymentsTotalCount }} registros</span>
          <div class="sp-pg">
            <button class="l-btn l-btn--ghost l-btn--sm" (click)="previousPaymentsPage()" [disabled]="paymentsPage === 0">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="sp-muted">{{ paymentsPage + 1 }} / {{ paymentsTotalPages || 1 }}</span>
            <button class="l-btn l-btn--ghost l-btn--sm" (click)="nextPaymentsPage()" [disabled]="paymentsPage >= paymentsTotalPages - 1">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

  </main>
</div>
